module.exports = __webpack_public_path__ + "static/media/armadillo-booking-2.a706660f.jpg";